import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './styles/global.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import './services/firebase'; // Eksplicit importér firebase for at sikre initialisering
import './i18n'; // Importerer i18n konfiguration

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Om du ønsker at måle ydeevnen i din app, kan du sende de indsamlede data
// til en analysetjeneste. Funktionen reportWebVitals giver dig mulighed for at gøre dette.
reportWebVitals();
